<div class="breadcrumb">
    <ul class="nav">
        <li class="nav-item">
          <a class="nav-link active" aria-current="true" href="https://{{urlDomain}}/Home/Dashboard">
            <span style="font-family:Rajdhani;color:#002F87;font-size:20px;">Home</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://{{urlDomain}}/TenantProfile/CompanyProfile">
            <span style="font-family:Rajdhani;color:#002F87;font-size:20px;">Company Profile</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled">
            <span style="font-family:Rajdhani;color:#002F87;font-size:20px;">Parker Profilex</span>
          </a>
        </li>
    </ul>
    </div>
